import * as React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Textarea,
  Label,
} from "@repo/ui";

interface CompleteReminderDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (completionNote?: string) => void;
  reminderTitle: string;
  isPharmacyReminder: boolean;
}

export function CompleteReminderDialog({
  open,
  onClose,
  onConfirm,
  reminderTitle,
  isPharmacyReminder,
}: CompleteReminderDialogProps) {
  const [note, setNote] = React.useState("");

  const handleConfirm = () => {
    onConfirm(note.trim() || undefined);
    setNote("");
    onClose();
  };

  const handleCancel = () => {
    setNote("");
    onClose();
  };

  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && handleCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Mark Reminder as Complete</AlertDialogTitle>
          <AlertDialogDescription>
            {isPharmacyReminder
              ? `You are marking the pharmacy reminder "${reminderTitle}" as complete. All pharmacy staff will see your name and completion time.`
              : `Mark "${reminderTitle}" as complete?`}
          </AlertDialogDescription>
        </AlertDialogHeader>

        <div className="space-y-2 py-2">
          <Label htmlFor="completion-note">
            Completion note {!isPharmacyReminder && "(optional)"}
          </Label>
          <Textarea
            id="completion-note"
            placeholder={
              isPharmacyReminder
                ? "Add a note about what was done..."
                : "Add an optional note..."
            }
            value={note}
            onChange={(e) => setNote(e.target.value)}
            maxLength={1000}
            rows={3}
          />
          <p className="text-xs text-muted-foreground text-right">
            {note.length}/1000
          </p>
        </div>

        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            data-testid="reminder-complete-confirm"
            onClick={handleConfirm}
          >
            Mark Complete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
